module.exports = __webpack_public_path__ + "static/media/Calibre-Regular.96e0a7c4.ttf";